import React from 'react';
import { aboutContent } from '../../content/about-content';
import { ComparisonTable } from './infographics';

/**
 * Neuromyths Section
 *
 * Dispels common myths about how the brain learns.
 */
const NeuromythsSection = React.forwardRef(({ id = 'myths' }, ref) => {
  const { neuromyths } = aboutContent;

  return (
    <section id={id} ref={ref} className="about-section">
      <header className="about-section__header">
        <h2 className="about-section__title">
          <svg className="about-section__title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
          {neuromyths.title}
        </h2>
        <p className="about-section__subtitle">{neuromyths.intro}</p>
      </header>

      <ComparisonTable
        rows={neuromyths.myths}
        mythHeader="Common Myth"
        realityHeader="What Science Says"
        showSources={true}
      />

      {/* What We DO Apply */}
      <div style={{ marginTop: '2.5rem' }}>
        <h3 style={{
          fontFamily: 'var(--lrbrain-font-mono)',
          fontSize: '0.9rem',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'var(--lrbrain-navy)',
          marginBottom: '1rem'
        }}>
          What We DO Apply
        </h3>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '0.75rem'
        }}>
          {[
            'Evidence-informed strategies with neuroscience backing',
            'Multiple representation formats for all concepts',
            'Growth mindset language consistently',
            'Spaced and interleaved practice',
            'Emotional safety as prerequisite to learning',
            'Social learning and collaboration',
            'Metacognitive skill building'
          ].map((item, index) => (
            <li
              key={index}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.75rem',
                padding: '0.75rem 1rem',
                background: 'rgba(16, 185, 129, 0.06)',
                borderRadius: '8px',
                fontSize: '0.9rem',
                color: 'var(--lrbrain-text)'
              }}
            >
              <span style={{
                color: '#10b981',
                fontWeight: '700',
                fontSize: '1rem',
                lineHeight: '1.4'
              }}>
                ✓
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
});

NeuromythsSection.displayName = 'NeuromythsSection';

export default NeuromythsSection;
